import { type ReactNode, useEffect } from 'react';

import {
  useEnvironment,
  useUserEnvironmentActions,
} from '#/contexts/UserEnvironmentContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { configureUserTracking } from '#/rendering/client/utils/configureUserTracking';
import { renderingWaitForInitUserEnvironmentToBeSet } from '#/rendering/client/utils/renderingWaitForInitUserEnvironmentToBeSet';

import { RenderingClientLocationHooks } from './RenderingClientLocationHooks';

type Props = {
  children: ReactNode;
};

export function RenderingClientInnerWrapper({ children }: Props) {
  const { locale } = useI18n();
  const { environment } = useEnvironment();
  const { setUserEnvironment } = useUserEnvironmentActions();

  useEffect(() => {
    // Only get user data from initUserEnvironment if environment is not loaded from SSR
    if (environment) return;

    async function fetch() {
      const apiResponse = await renderingWaitForInitUserEnvironmentToBeSet();

      setUserEnvironment({
        user: apiResponse.user,
        environment: apiResponse.environment,
      });

      configureUserTracking({
        user: apiResponse.user,
        environment: apiResponse.environment,
        locale,
      });
    }

    fetch();
  }, [locale, environment, setUserEnvironment]);

  return (
    <>
      {children}
      <RenderingClientLocationHooks />
    </>
  );
}
